// src/features/tag-types/components/TagTypeActions.tsx

import React, { useState } from 'react';
import { useTranslate, useRedirect } from 'react-admin';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Box } from '@mui/material';
import { MoreVert as MoreVertIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTagTypePermissions } from '../hooks/useTagTypePermissions';
import { TagType } from '../types';
import BaseDeleteDialog from '../../../components/common/BaseDeleteDialog';

interface TagTypeActionsProps {
  record: TagType;
}

const TagTypeActions: React.FC<TagTypeActionsProps> = ({ record }) => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const permissions = useTagTypePermissions(record);
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleMenuClose = () => setAnchorEl(null);
  const handleEdit = () => {
    handleMenuClose();
    redirect(`/tag-types/${record.id}`);
  };
  const handleDeleteClick = () => {
    handleMenuClose();
    setShowDeleteDialog(true);
  };

  // No mostrar menú si no hay acciones posibles
  if (!permissions.canEditThis && !permissions.canDeleteThis) {
    return null;
  }
  
  return (
    <>
     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Tooltip title={translate('ra.action.menu', 'Más opciones')}>
              <IconButton
                  size={'small'}
                  onClick={handleMenuOpen}
                  sx={{ color: 'action.active' }}
              >
                  <MoreVertIcon fontSize={'small'} />
              </IconButton>
          </Tooltip>
      </Box>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {permissions.canEditThis && (
          <MenuItem onClick={handleEdit}>
            <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{translate('ra.action.edit')}</ListItemText>
          </MenuItem>
        )}
        {permissions.canDeleteThis && (
          <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
            <ListItemIcon><DeleteIcon fontSize="small" color="error" /></ListItemIcon>
            <ListItemText>{translate('ra.action.delete')}</ListItemText>
          </MenuItem>
        )}
      </Menu>

      {showDeleteDialog && (
        <BaseDeleteDialog
          open={showDeleteDialog}
          onClose={() => setShowDeleteDialog(false)}
          resource="tag-types"
          recordId={record.id}
          title="Eliminar Tipo de Tag"
          message={`¿Estás seguro de que quieres eliminar el tipo de tag "${record.name}"?`}
          warningMessage="Esta acción no se puede deshacer."
        />
      )}
    </>
  );
};

export default TagTypeActions;